import React from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

import {
  classPath,
  homePath,
  selectTextbookPath,
  selectDataPath,
  textbookPath,
  chooseTextbookPath,
  activeLearningTextbookPath,
  activeLearningClassDataPath,
  questionnairePath,
  questionnaireStatisticsPath,
  classDataPath,
  projectionPath,
  assessmentDescriptionPath,
  assessmentPath,
  defaultPath,
  activeLearningProjectionPath,
  videoLessonPath,
} from "../../../teacherStore";
import { isAvailablePartItemCodes } from "../../../libs/ActiveLearning";
import LogoImg from "../../../assets/images/logo.png";
import { ReactComponent as HomeIcon } from "../../../assets/svg/home-menu.svg";
import { ReactComponent as BookIcon } from "../../../assets/svg/book.svg";
import { ReactComponent as ClassSettingIcon } from "../../../assets/svg/discussion.svg";
import { ReactComponent as StudentDataIcon } from "../../../assets/svg/class-data.svg";
import { ReactComponent as AssessmentIcon } from "../../../assets/svg/assessment.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/svg/logout.svg";
import Modal from "../../../atoms/Modal";

import styles from "./LoginHeader.module.scss";

export interface LoginHeaderProps {
  isOnlyAssessment: boolean;
  availableItemCodes: string[];
  logout: () => void;
  educationGoal: string;
}

export const LoginHeader = (props: LoginHeaderProps) => {
  const [showModal, setShowModal] = React.useState(false);
  const { pathname } = useLocation();

  const activePath = (...args: string[]) =>
    clsx(args.some(compare => pathname.includes(compare)) && styles.active);

  const shouldHideHeader = [
    projectionPath,
    videoLessonPath,
    activeLearningProjectionPath,
  ].some(path => pathname.includes(path));

  return !shouldHideHeader ? (
    <div className={styles.container}>
      <div className={styles.sidebarWrapper}>
        <nav className={styles.sidebar}>
          <a className={styles.logo} href={defaultPath}>
            <img src={LogoImg} alt="Logo" />
          </a>
          <ul className={styles.menuList}>
            {!props.isOnlyAssessment && (
              <>
                <li className={activePath(homePath)}>
                  <Link aria-current="page" to={homePath}>
                    <HomeIcon />
                    HOME
                  </Link>
                </li>
                <li
                  className={activePath(
                    selectTextbookPath,
                    textbookPath,
                    chooseTextbookPath,
                    activeLearningTextbookPath,
                  )}
                >
                  <Link
                    aria-current="page"
                    to={
                      isAvailablePartItemCodes(props.availableItemCodes)
                        ? selectTextbookPath
                        : `${textbookPath}${chooseTextbookPath}`
                    }
                  >
                    <BookIcon />
                    指導書を選ぶ
                  </Link>
                </li>
                <li
                  className={
                    activePath(classPath) ||
                    activePath(questionnairePath) ||
                    activePath(questionnaireStatisticsPath)
                  }
                >
                  <Link aria-current="page" to={classPath}>
                    <ClassSettingIcon />
                    クラス設定
                  </Link>
                </li>
                <li
                  className={activePath(
                    selectDataPath,
                    classDataPath,
                    activeLearningClassDataPath,
                  )}
                >
                  <Link
                    aria-current="page"
                    to={
                      isAvailablePartItemCodes(props.availableItemCodes)
                        ? selectDataPath
                        : classDataPath
                    }
                  >
                    <StudentDataIcon />
                    生徒データ
                  </Link>
                </li>
              </>
            )}
            <li
              className={activePath(assessmentDescriptionPath, assessmentPath)}
            >
              <Link aria-current="page" to={assessmentDescriptionPath}>
                <AssessmentIcon />
                自己評価ツール
              </Link>
            </li>
            {props.isOnlyAssessment && (
              <li>
                <button onClick={() => setShowModal(true)}>
                  <LogoutIcon />
                  ログアウト
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
      {showModal && (
        <Modal
          onClose={() => setShowModal(false)}
          className={styles.modalLogout}
        >
          <div className={styles.modalLogout__title}>ログアウトしますか？</div>
          <div className={styles.modalLogout__actions}>
            <button
              className={styles.btnCancel}
              onClick={() => setShowModal(false)}
            >
              キャンセル
            </button>
            <button className={styles.btnOk} onClick={props.logout}>
              ログアウト
            </button>
          </div>
        </Modal>
      )}
    </div>
  ) : null;
};

export default LoginHeader;
